import React from 'react';
import { useRecoilState, useSetRecoilState } from 'recoil';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { FlexBox, FlexBoxCenter, FlexBoxColumn, HorizontalDivider } from '@ecp/common/src/layouts/flex/styled';
import { Spacing } from '@ecp/common/src/layouts/Spacing';
import { TextBox } from '@ecp/common/src/text/TextBox';
import Drawer from '@ecp/common/src/components/modal/bo/Drawer';
import Button from '@ecp/common/src/components/button/bo/Button';
import TooltipInfoIcon from '@ecp/common/src/assets/icon/icon__tooltip-info.svg';

import { alarmPopupState, alarmState } from '@bo-recoil/common/alarm/atom';
import CommonApi from '@bo-apis/common/commonApi';
import AlarmItem from '@bo-layout/gnb/alarm/AlarmItem';

const AlarmDrawer = ({ isDrawerOpen, onDrawerClose }) => {
  const setPopupOpen = useSetRecoilState(alarmPopupState);
  const [items, setItems] = useRecoilState(alarmState);

  const handleAllReadClick = async () => {
    const result = await CommonApi.changeReadStatus({ alarmType: 'ALL' });
    if (result) {
      setPopupOpen(false);
      setItems([]);
    }
  };

  return (
    <Drawer onClose={onDrawerClose} open={isDrawerOpen} rootProps={{ width: '420px' }}>
      <FlexBox width={'100%'} gap={'14px'}>
        <TextBox font-size={'22px'} weight={'700'}>
          알림함
        </TextBox>
        <Button type={'Third'} width={'68px'} lineHeight={'28px'} onClick={handleAllReadClick} disabled={false}>
          모두읽음
        </Button>
      </FlexBox>
      <Spacing top={5} />
      <FlexBox gap={'6px'} align-self={'flex-start'}>
        <img src={TooltipInfoIcon} alt={'TooltipInfoIcon'} />
        <TextBox size={13} weight={400} color={'#333'}>
          알림은 오늘 기준 10일치를 보여줍니다.
        </TextBox>
      </FlexBox>
      <Spacing top={25} />
      <HorizontalDivider width={'100%'} height={'4px'} color={'#666'} />
      <Spacing top={10} />
      {items.length > 0 ? (
        <AlarmItemsHolder>
          {items.map((item, index) => (
            <AlarmItem key={`k-${index}`} {...item} />
          ))}
        </AlarmItemsHolder>
      ) : (
        <NoDataWrapper>
          <TextBox font-size={15} font-weight={300} color={'#999'}>
            알림이 없습니다.
          </TextBox>
        </NoDataWrapper>
      )}
    </Drawer>
  );
};

const AlarmItemsHolder = styled(FlexBoxColumn)`
  width: 100%;
  height: fit-content;
  gap: 10px;
`;

const NoDataWrapper = styled(FlexBoxCenter)`
  width: 100%;
  height: 80px;
`;

AlarmDrawer.propTypes = {
  isDrawerOpen: PropTypes.bool,
  onDrawerClose: PropTypes.func,
};

export default AlarmDrawer;
